// extracted by mini-css-extract-plugin
export var link = "_ub-0";